import { TransferTranslations } from "./transferTranslations.types";

const transferNlTranslations: TransferTranslations = {
    "transferPage": {
        "title": "Transfer",
    },
    "bus": {
        title: 'Bus',
        estimatedTransferTime: 'Geschatte transfertijd:',
        note: 'Kan buswissels onderweg vereisen of lopen naar uw verblijf.',
        description: 'Een gedeelde shuttle met vaste tijden en meerdere stopplaatsen. Buswissels of lopen kunnen nodig zijn.'
    },
    "taxi": {
        title: 'Taxi',
        estimatedTransferTime: 'Geschatte transfertijd:',
        note: 'Deur-tot-deur service',
        description: 'Een privé-transfer met een gedelegeerde chauffeur voor uw exclusieve gebruik.'
    },
    "funicular": {
        title: 'Funiculaire',
        estimatedTransferTime: 'Geschatte transfertijd:',
        note: 'Deur-tot-deur service',
        description: 'Een funiculaire privé-transfer met een gedelegeerde chauffeur voor uw exclusieve gebruik.'
    }
}

export default transferNlTranslations;